import {Flex, Spinner, Stat, StatLabel, StatNumber, useColorModeValue,} from "@chakra-ui/react";
// Custom components
// Custom icons
import React from "react";
import {useNavigate} from "react-router-dom";

export default function DashboardCard({heading, startContent, count, link, isLoading}) {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const textColorSecondary = "secondaryGray.600";
    const navigate = useNavigate()

    return (
        <Flex
            borderRadius='15px'
            overflow='hidden'
            p={15}
            background={link === '' ? "secondaryGray.200" : "white"}
            onClick={() => navigate(link)}
            cursor={link === '' ? "not-allowed" : "pointer"}
            h='100%'
            align={{base: "center", xl: "center"}}
            justify={{base: "center", xl: "center"}}>
            {startContent}
            <Stat my='0' marginLeft='20px'>
                <StatLabel
                    color={textColor}
                    fontSize={{
                        base: "3xl",
                    }}
                    fontWeight={700}
                >
                    {heading}
                </StatLabel>
                <StatNumber
                    color={textColorSecondary}
                    fontSize={{
                        base: "lg",
                    }}
                    fontWeight={500}
                >
                    Total {heading} : {!isLoading ? count : (
                    // <Box display="flex" justifyContent="center" alignItems="center">
                    <Spinner size="sm" color="blue"/>
                    // </Box>
                )}
                </StatNumber>
            </Stat>
        </Flex>
    );
}

// if (isLoading) {
//     return (
//         <Box display="flex" justifyContent="center" alignItems="center" height="200px">
//             <Spinner size="xl" color="blue"/>
//         </Box>
//     );
// }
